.pageContent {
  display: flex;
  gap: 20px;
}
.pageContent > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 0;
}
.pageContent p {
  margin: 8px 0;
}
.sectionContainer {
  background: var(--static-background-strong);
  border-radius: 14px;
  border: 1px solid var(--static-divider-standard);
  overflow: hidden;
}
.sectionContainer.active {
  border-color: var(--color-primary);
  border-width: 2px;
}
.sectionContainer.disabled {
  filter: grayscale();
  opacity: 0.7;
}
.sectionContent {
  padding: 14px 16px;
}
.sectionContainer.active .sectionContent {
  padding-left: 15px;
  padding-right: 15px;
}
.sectionContent.header {
  padding-bottom: 6px;
}
.sectionContainer.active .sectionContent.header {
  padding-top: 13px;
}
.sectionContainer.active .sectionContent.footer {
  padding-bottom: 13px;
}
h1 {
  font-weight: var(--font-weight-strong);
}
.icon {
  display: flex;
  cursor: help;
}
.spacer {
  flex: 1;
}
.row {
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: stretch;
}
.row:not(:last-of-type) {
  margin-bottom: 4px;
}
.datePicker {
  width: auto;
}
.placementOption {
  cursor: pointer;
}
.shipmentDestinations.spd {
  border: 1px solid var(--static-divider-standard);
  border-width: 1px 0;
  padding: 6px 0;
  margin: 0 18px;
  overflow: hidden;
  width: calc(100% - 36px);
}
.shipmentDestination.spd {
  display: flex;
  padding-right: 8px;
  border-right: 1px solid var(--static-divider-standard);
  gap: 6px;
  align-items: center;
}
.shipmentDestinations.ltl {
  border-top: 1px solid var(--static-divider-standard);
  border-bottom: 1px dashed var(--static-divider-standard);
  overflow: auto hidden;
}
.shipmentDestination.ltl {
  white-space: nowrap;
}
.shipmentDestination:last-child {
  padding-right: 0;
  border-right: none;
}
.grid {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.25rem 0.5rem;
  padding-top: 14px;
  padding-bottom: 14px;
  width: 100%;
  border-bottom: 1px dashed var(--static-divider-standard);
}
.grid:last-child {
  border-bottom: none;
}
.fee {
  color: var(--static-text-weak);
}
.fee.right {
  color: var(--static-text-strong);
}
.footer .fee {
  color: var(--static-text-strong);
  font-weight: var(--font-weight-strong);
  font-size: var(--fs-small-heading);
}
.shipmentAddresses {
  border-bottom-style: solid;
}
.right {
  text-align: right;
}
.totalFees {
  padding-top: 14px;
}
.shipmentDetails {
  display: grid;
  flex: 1;
  grid-template-columns: max-content 1fr;
}
.shipmentDetails > span {
  padding: 2px 16px 2px 0;
}
.viewContentsModal {
  width: calc(100vw - 24px);
  max-width: 800px;
}
.shipmentContents {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.totalFees.info {
  background: var(--sentiment-background-info);
}
.continueHeader {
  border-bottom: 1px solid var(--static-divider-standard);
}
.continueFees {
  font-size: var(--fs-small-heading);
  font-weight: var(--font-weight-strong);
  color: var(--static-text-normal);
}
.shipmentTabItem {
  padding: 8px 11px;
}
.shipmentTabItem:first-child {
  padding-left: 18px;
}
